export default __webpack_public_path__ + "static/media/logooc.4bbe8df4.png";